var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.83398H15.6682C16.3418 1.83398 16.9918 2.08115 17.4952 2.52861C18.6304 3.53763 18.7326 5.27583 17.7236 6.41098L13.3341 11.3481V17.2009C13.3341 17.4721 13.2836 17.7403 13.1858 17.992L13.1036 18.1774C12.5643 19.256 11.2528 19.6932 10.1742 19.1539L9.35428 18.7439C8.42263 18.2781 7.83412 17.3259 7.83412 16.2843V11.3499L3.44462 6.41098C3.04191 5.95793 2.80144 5.38605 2.75737 4.78521L2.75 4.58398C2.75 3.0652 3.98122 1.83398 5.5 1.83398ZM15.6682 3.66732H5.5C4.99374 3.66732 4.58333 4.07772 4.58333 4.58398C4.58333 4.80849 4.66572 5.02519 4.81487 5.19298L9.43591 10.3917C9.58506 10.5594 9.66745 10.7761 9.66745 11.0007V16.2843C9.66745 16.6315 9.86362 16.9489 10.1742 17.1041L10.9941 17.5141C11.167 17.6006 11.3773 17.5305 11.4638 17.3575C11.4881 17.3089 11.5008 17.2553 11.5008 17.2009V11.0007C11.5008 10.7761 11.5832 10.5594 11.7323 10.3917L16.3534 5.19298C16.6897 4.8146 16.6556 4.2352 16.2772 3.89886C16.1094 3.74971 15.8927 3.66732 15.6682 3.66732Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.23093a94dd24a5c4fdbc1ed9909c373b.svg";
export { ForwardRef as ReactComponent };